import PropTypes from 'prop-types'
import { Grid, Box, Typography, Stack } from '@mui/material'
import Input from 'components/generic/form/Input'
import Checkbox from 'components/generic/form/Checkbox'
import InputFormat from 'components/generic/inputs/formatting/InputFormat'
import Switch from 'components/generic/form/Switch'

const ContractFreightCost = ({ isView, methods, carrierPricePrepend }) => {
  const { control, watch, errors } = methods
  const consumerFreightEnabled = watch('freightPricing.consumerFreightEnabled')

  return (
    <Box sx={{ mt: 4 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Stack direction="row" spacing={2} alignItems="center">
            <Typography variant="h6" color="textSecondary">
              Freight Cost and Chargeback
            </Typography>
            <Switch
              label={consumerFreightEnabled ? 'Enabled' : 'Disabled'}
              name="freightPricing.consumerFreightEnabled"
              defaultValue={false}
              control={control}
              variant="outlined"
              sx={{ ml: 2 }}
              disabled={isView}
              labelPlacement="end"
            />
          </Stack>
        </Grid>

        <Grid item xs={12}>
          <Stack direction="row" spacing={4}>
            <Input
              name="freightPricing.consumerFreightCost"
              label="Freight Cost"
              size="small"
              fractionDigits={2}
              defaultValue={0}
              disabled={isView || !consumerFreightEnabled}
              control={control}
              error={!!errors?.freightPricing?.consumerFreightCost}
              helperText={errors?.freightPricing?.consumerFreightCost?.message}
              InputProps={{
                inputComponent: InputFormat,
                inputProps: {
                  inputType: 'price',
                  pricePrepend: carrierPricePrepend,
                  onChange: () => {},
                  decimalScale: 2,
                  allowNegative: false,
                },
                ...(isView || !consumerFreightEnabled ? { disableUnderline: true } : {}),
              }}
              InputLabelProps={{
                ...(isView || !consumerFreightEnabled ? { shrink: true } : {}),
              }}
              sx={{
                width: '20%',
              }}
            />
            <Input
              name="freightPricing.consumerFreightChargeback"
              label="Freight Chargeback"
              size="small"
              fractionDigits={2}
              defaultValue={0}
              disabled={isView || !consumerFreightEnabled}
              control={control}
              error={!!errors?.freightPricing?.consumerFreightChargeback}
              helperText={errors?.freightPricing?.consumerFreightChargeback?.message}
              InputProps={{
                inputComponent: InputFormat,
                inputProps: {
                  inputType: 'price',
                  pricePrepend: carrierPricePrepend,
                  onChange: () => {},
                  decimalScale: 2,
                  allowNegative: false,
                },
                ...(isView || !consumerFreightEnabled ? { disableUnderline: true } : {}),
              }}
              InputLabelProps={{
                ...(isView || !consumerFreightEnabled ? { shrink: true } : {}),
              }}
              sx={{
                width: '20%',
              }}
            />
            <Checkbox
              name="freightPricing.consumerFreightNegativeChargeback"
              control={control}
              label={
                <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
                  Yard will pay freight chargeback on invoice
                </Typography>
              }
              disabled={!consumerFreightEnabled || isView}
              data-testid={`consumer-freight-negative-chargeback-checkbox`}
            />
          </Stack>
        </Grid>
      </Grid>
    </Box>
  )
}

ContractFreightCost.propTypes = {
  isView: PropTypes.bool,
  control: PropTypes.object.isRequired,
  watch: PropTypes.func.isRequired,
  errors: PropTypes.object,
  carrierPricePrepend: PropTypes.string,
}

ContractFreightCost.defaultProps = {
  isView: false,
  errors: {},
  carrierPricePrepend: '$',
}

export default ContractFreightCost
